define('lib/backbone/Backbone.PodioModel',['require','underscore','backbone','backbone-super','backbone.trackit','lib/backbone/Backbone.Mixins.Transport','lib/backbone/backbone-validation-amd','lib/backbone/Backbone.PodioEvents','lib/Podio.Logger'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  require('backbone-super');
  require('backbone.trackit');

  var MixinTransport = require('lib/backbone/Backbone.Mixins.Transport');
  var BackboneValidation = require('lib/backbone/backbone-validation-amd');
  var PodioEvents = require('lib/backbone/Backbone.PodioEvents');
  var podioLogger = require('lib/Podio.Logger');

  function resolveReference(referenceName) {
    return require(referenceName);
  }

  var PodioModel = Backbone.Model.extend({
    urlFunc: function(rootFunc) {
      var url;

      if (this.useDirectAPIAccess) {
        url = this._getAPIHostName() + _.result(this, rootFunc+'API');
      } else {
        url = _.result(this, rootFunc+'Rails');
      }

      return url;
    },

    urlRoot: function() {
      // this method will be overwritten if there is a custom urlRoot
      // thus we stay compatible to the current code
      return this.urlFunc('urlRoot');
    },

    url: function() {
      // this method will be overwritten if there is a custom url
      // thus we stay compatible to the current code
      if (_.isUndefined(this.urlAPI) && _.isUndefined(this.urlRails)) {
        return this._super();
      } else {
        return this.urlFunc('url');
      }
    },

    _isBackboneEntity: function(val) {
      return (val instanceof Backbone.Collection || val instanceof Backbone.Model);
    },

    _handleNestedModels : function(attr, value, options) {

      // TODO: Simplify this method, and remove redundency.

      var now = this.attributes;
      var model;
      var relations;
      var reference;
      var instance;

      if ( this.has_one ) {
        relations = this.has_one();

        if(!_.isUndefined(relations[attr])) {

          reference = relations[attr];

          if(!reference) {
            podioLogger.log('Reference for has_one model couldnt be ressolved', attr, this);
          }

          model = reference ? reference : resolveReference('lib/backbone/Backbone.PodioModel');

          // if is already a Backbone model, just reset it
          if (now[attr] instanceof Backbone.Model) {
            this.changed[attr] = now[attr];
            if (!options.deep) {
              this.changed[attr].clear({ silent: true });
            }
            this.changed[attr].set(value);
          } else {
            instance = new model(value);
            instance.relationParent = this;
            this.changed[attr] = instance;
          }
        }
      }


      if ( this.has_many ) {
        relations = this.has_many();

        if(!_.isUndefined(relations[attr])) {
          reference = relations[attr];

          if(!reference) {
            podioLogger.log('Reference for has_many model couldnt be ressolved', attr, this);
          }

          var collection = reference ? reference : resolveReference('lib/backbone/Backbone.PodioCollection');

          // if is already a Backbone collection, just reset it
          if (now[attr] instanceof Backbone.Collection) {
            this.changed[attr] = now[attr];
            this.changed[attr].set(value);    /* will remove missing models on default in Backbone 1.x */
          } else {
            instance = new collection(value);
            instance.relationParent = this;
            this.changed[attr] = instance;
          }
        }
      }

    },

    _deepMerge: function(target, val, triggerName) {
      var changed = false;

      _.each(val, function(propVal, propName) {
        if (_.isObject(propVal) && !_.isArray(propVal)) {
          // Override non-object values
          target[propName] = _.isObject(target[propName]) ? target[propName] : {};
          changed = changed ||
                    this._deepMerge(target[propName], propVal, triggerName+"."+propName);
        } else {
          // Always trigger change for arrays
          if (_.isArray(propVal) || !_.isEqual(target[propName], propVal)) {
            target[propName] = propVal;
            changed = true;
            this.trigger("change:"+triggerName+"."+propName, this, propVal);
          }
        }
      }, this);

      // Trigger change on parent property if any nested properties changed
      if(changed) {
        this.trigger("change:"+triggerName, this, val);
      }

      return changed;
    },

    _setProperty: function(val, attr, options) {
      if (_.isObject(this.attributes[attr]) && _.isObject(val) && options.deep && !this._isBackboneEntity(val)) {
        this._deepMerge(this.attributes[attr], val, attr);
      } else {
        this.attributes[attr] = val;
      }
    },

    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key === null) {
        return this;
      }

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = options || {};

      // Run validation.
      if (!this._validate(attrs, options)) {
        return false;
      }

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes;
      prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) {
        this.id = attrs[this.idAttribute];
      }

      // For each `set` attribute, update or delete the current value.
      Object.keys(attrs).forEach(function (attr) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) {
          changes.push(attr);
        }
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;

          // added by Podio - begin
          if (!_.isNull(val) && !this._isBackboneEntity(val)) {
            this._handleNestedModels(attr, val, options);
          }
          // added by Podio - end
        } else {
          delete this.changed[attr];
        }
        if (unset) {
          delete current[attr];
        } else {
          this._setProperty(this.changed[attr] || val, attr, options);
        }
      }.bind(this));

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) {
          this._pending = options;
        }
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      if (changing) {
        return this;
      }
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    reset: function(data) {
      this.clear().set(data);
    },

    getModelWithReferences: function() {
      var model = this.clone();

      // removing our related models before submitting
      Object.keys(model.attributes).forEach(function (prop) {
        var property = model.attributes[prop];

        if ( !_.isArray(property) && (property instanceof Backbone.Model)) {
          delete model.attributes[prop];
        }
      }.bind(this));

      return model;
    },

    parse : function (response, xhr) {
      if (response && response.status == 'ok' && response.data.object) {
        // if the parse is called by fetch function of the model
        return response.data.object;
      } else {
        // if the parse function is called from the collection, populate the model directly
        return response;
      }
    },

    fetch : function(options) {
      if (!options || !options['silentLoading']) {
        this.trigger('loading');
      }

      this.fetchAttempted = true;

      return this._super(options);
    },

    can : function(right) {
      return _.indexOf(this.get('rights'), right) > -1;
    },

    isEmpty: function() {
      return _.isEmpty(this.attributes);
    },

    index: function() {
      if (!this.collection) {
        throw 'This model is not part of any collection';
      } else {
        return this.collection.indexOf(this);
      }
    },

    toJSON : function(options) {
      var json;
      if(!options || !options.recursive) {

        //  Fallback to super method if non-resursive
        json = this._super();
        if(this.paramRoot) {
          var wrapper = {};
          wrapper[this.paramRoot] = json;
          return wrapper;
        } else {
          return json;
        }

      } else {

        if (this._isSerializing) {
          return this.id || this.cid;
        }

        this._isSerializing = true;
        json = _.clone(this.attributes);

        _.each(json, function(value, name) {

          if (value && _.isFunction(value.toJSON) ) {
            json[name] = value.toJSON(options);
          }

        });

        this._isSerializing = false;
        return json;
      }
    }

  });

  // Mixin Podio Events and common transport layer
  _.extend(PodioModel.prototype, PodioEvents, MixinTransport, BackboneValidation.mixin);
  PodioModel.prototype.set = _.wrap(PodioModel.prototype.set, Backbone.Trackit.set);

  return PodioModel;

});

